import * as React from 'react';
import { navigate } from 'router';
import CurrentOrgInjector from '~/apps/shared/containers/app/CurrentOrgInjector';
import OrgUserListTable from './OrgUserListTable';

export default function() {
  return (
    <CurrentOrgInjector
      component={OrgUserListTable}
      onEdit={(userId) => navigate('pos.admin.settings.team.edit', {userId})}
      onDelete={(userId) => navigate('pos.admin.settings.team.confirm', {userId})}
    />
  );
}
